import { Loader } from '@/components/Loader';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { useMyPurchasesQuery } from '@/generated/graphql';
import { useAdminScreenThemeState } from '@/providers/AdminScreenThemeStateProvider/AdminScreenThemeStateContext';
import { PaymentSubscriptionCard } from './PaymentSubscriptionCard';
import { EventPassCard } from './EventPassCard';
import { cn } from '@/lib/utils';
import { toast } from 'sonner';

export function GoLiveDialog({
  open,
  onOpenChange,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}) {
  const { event } = useAdminScreenThemeState();

  const { data, loading, error } = useMyPurchasesQuery({
    fetchPolicy: 'network-only',
  });

  const onEventLive = () => {
    toast.success('Your event is now live!');
    onOpenChange(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <span>Go Live:</span>
            <span className="text-muted-foreground">{event.name}</span>
          </DialogTitle>
          <DialogDescription>
            Choose an option below to go live with this screen.
          </DialogDescription>
        </DialogHeader>
        <div className="flex flex-col gap-4">
          {loading && <Loader />}
          {error && <div>Error: {error.message}</div>}
          {data && (
            <div
              className={cn(
                'flex flex-col gap-4',
                data?.mySubscription && 'flex-col-reverse',
              )}
            >
              <EventPassCard
                event={event}
                eventPasses={data?.myEventPasses || []}
                price={data?.pricing.eventPass}
                onEventLive={onEventLive}
              />
              <PaymentSubscriptionCard
                event={event}
                subscription={data?.mySubscription}
                price={data?.pricing.subscription}
                onEventLive={onEventLive}
              />
            </div>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
}
